import React, { useState } from "react";
import { FaPython, FaReact, FaFilePdf, FaGoogleDrive, FaLaptopCode, FaBrain } from "react-icons/fa";
import { SiTailwindcss, SiPostgresql, SiExpress, SiTypescript, SiPrisma, SiScikitlearn, SiStreamlit, SiFastapi, SiPandas, SiGooglecloud, SiNestjs, SiNodedotjs, SiNextdotjs } from "react-icons/si";
import RadioTabs from './reutilizables/RadioTabs';
import boftimg from '../imgs/boft.webp';
import maprounidadimg from '../imgs/Maprounidad.webp';
import quikbiteimg from '../imgs/QuickBite.png';
import taiyoWebImg from '../imgs/taiyo-web.webp';
import taiyoPanelImg from '../imgs/taiyo-panel.png';
import opiekaCompanyImg from '../imgs/opieka-company.png';
import cuvServicesImg from '../imgs/CuvServices.png';
import cuvServicesSubirImg from '../imgs/CuvServicesSubir.png';

const ProjectsSection = ({ language = 'es' }) => {
  const [modalData, setModalData] = useState({ show: false, title: "", content: [], images: [] });
  const [companyProjectsModal, setCompanyProjectsModal] = useState({ show: false, companyTitle: "", projects: [] });
  const [selectedCategory, setSelectedCategory] = useState('personal');
  const [showAllProjectsModal, setShowAllProjectsModal] = useState(false);
  const [allProjectsCategory, setAllProjectsCategory] = useState('personal');

  const openModal = (title, content, images = []) => {
    setModalData({ show: true, title, content, images });
  };

  const closeModal = () => {
    setModalData({ show: false, title: "", content: [], images: [] });
  };

  const closeCompanyProjectsModal = () => {
    setCompanyProjectsModal({ show: false, companyTitle: "", projects: [] });
  };

  const handleProjectClick = (project, closeAllProjects = false) => {
    if (project.companyProjects && project.companyProjects.length > 0) {
      setCompanyProjectsModal({
        show: true,
        companyTitle: project.title,
        projects: project.companyProjects,
      });
      if (closeAllProjects) {
        setShowAllProjectsModal(false);
      }
      return;
    }

    openModal(project.title, project.description, project.images || []);
    if (closeAllProjects) {
      setShowAllProjectsModal(false);
    }
  };

  // Textos en diferentes idiomas
  const texts = {
    es: {
      projectsTitle: "Proyectos",
      categories: {
        personal: "Personales",
        academic: "Estudiantiles",
        professional: "Profesionales"
      },
      maprounidad: {
        title: "Maprounidad",
        description: [
          "Este software es un sistema de gestión financiera y administrativa, diseñado para organizaciones que requieren llevar un control detallado de los aportes y préstamos de sus miembros.",
          "Está orientado a facilitar el manejo de operaciones financieras comunes como el registro y seguimiento de aportes, la gestión de préstamos, y la generación de informes personalizados.",
          "Tecnologías utilizadas: Python, React, PostgreSQL y generación de documentos PDF.",
        ],
      },
      boft: {
        title: "Boft Fotografías Colombia",
        description: [
          "Boft es una empresa internacional especializada en la impresión de fotografías, conocida por sus franquicias y kioscos ubicados en diversas partes del mundo.",
          "Boft Colombia, además de sus kioscos a nivel nacional, decidió expandir sus operaciones al ámbito digital.",
          "Se desarrolló una plataforma que permite a los usuarios subir sus imágenes, procesar pagos en línea y recibir sus fotografías impresas directamente en sus domicilios.",
          "Tecnologías utilizadas: Python, React, PostgreSQL, generación de documentos PDF y Google Drive para almacenamiento en la nube.",
        ],
      },
      quickbite: {
        title: "QuickBite",
        description: [
          "QuickBite es una plataforma SaaS empresarial que ofrece soluciones integrales para restaurantes, ferreterías y comercios en general.",
          "La plataforma incluye gestión de mesas, pedidos digitales, control de inventario, códigos de barras, punto de venta y analytics empresariales.",
          "Diseñada específicamente para maximizar la eficiencia operativa de diferentes tipos de negocio con funcionalidades especializadas por industria.",
          "Actualmente cuenta con más de 1,200 empresas activas, 98.7% de satisfacción del cliente y un ROI promedio del 35%.",
          "Proyecto en desarrollo - Tecnologías: React, Python, PostgreSQL, Tailwind CSS, Supabase.",
        ],
      },
      muuva: {
        title: "MUUVA",
        description: [
          "MUUVA es una plataforma de comercio ganadero para Boyacá, Colombia que conecta vendedores y compradores de ganado (bovinos, porcinos, ovinos, etc.).",
          "Sistema de pagos protegidos estilo escrow (como MercadoLibre), donde el dinero se retiene hasta que el comprador confirme la entrega, garantizando seguridad para ambas partes.",
          "Diseñada especialmente para el contexto rural colombiano con registro simplificado vía WhatsApp y métodos de pago locales (Nequi, Daviplata, Wompi, Efecty, Bancolombia).",
          "Incluye sistema de subastas para ventas competitivas, upload de imágenes múltiples, catálogo con filtros avanzados y autenticación JWT.",
          "Proyecto en desarrollo - Tecnologías: React, TypeScript, Express, Prisma ORM, PostgreSQL, Tailwind CSS, Vite.",
        ],
      },
      emotionIA: {
        title: "EmotionIA - Clasificador de Emociones",
        description: [
          "Clasificador de emociones en texto que analiza mensajes en español o inglés y determina la emoción predominante: enojo, miedo, alegría, amor, tristeza o sorpresa.",
          "Sistema de feedback humano para mejorar el modelo continuamente, con traducción automática y 90% de precisión usando LightGBM optimizado.",
          "Interfaz web interactiva con Streamlit que incluye visualizaciones de probabilidades, matrices de confusión y análisis exploratorio de datos.",
          "Dataset de 420,458 registros con recopilación de 5,026 correcciones humanas para reentrenamiento.",
          "Tecnologías utilizadas: Python, LightGBM, scikit-learn, Streamlit, deep-translator, Plotly, pandas.",
        ],
      },
      pawmi: {
        title: "Pawmi - App de Cuidado de Mascotas con IA",
        description: [
          "Aplicación móvil de cuidado de mascotas con IA que predice enfermedades basándose en síntomas a través de un chat interactivo.",
          "Sistema completo con backend FastAPI, autenticación JWT y OAuth 2.0 con Google, gestión de mascotas y subida de imágenes a Supabase.",
          "Frontend en React Native con Expo, selector visual de mascotas, acciones rápidas (vacunas, desparasitación) y diseño moderno con gradientes.",
          "Modelo de Machine Learning con ExtraTreesClassifier alcanzando 98.15% de precisión en predicción de enfermedades veterinarias.",
          "Tecnologías utilizadas: React Native, FastAPI, PostgreSQL (Supabase), scikit-learn, TypeScript, SQLAlchemy, Expo.",
        ],
      },
      turismoGastronomico: {
        title: "Sistema ML para Turismo Gastronómico",
        description: [
          "Sistema inteligente de recomendaciones de restaurantes para turistas en Tunja, Boyacá usando Machine Learning con datos 100% reales. Un 'Netflix para restaurantes'.",
          "4 modelos ML: Random Forest (MAE 0.75), K-Means (4 clusters de turistas), TF-IDF búsqueda semántica, y pronóstico de demanda con 210 restaurantes y 14,553 interacciones reales.",
          "Chat inteligente con búsqueda semántica de platos, recomendaciones personalizadas basadas en historial y clustering, pronóstico de visitas para planificación de inventario.",
          "Dataset completo: 210 restaurantes verificados, 3,000 turistas con perfiles reales, análisis exploratorio y dashboard de evaluación de modelos.",
          "Proyecto de grado - Tecnologías: Python, scikit-learn, Streamlit, Pandas, NumPy, TF-IDF, K-Means, Random Forest.",
        ],
      },
      project4: {
        title: "Proyecto 4",
        description: [
          "Muy pronto...",
          "",
        ],
      },
      taiyoIngenieria: {
        title: "TAIYO Ingeniería S.A.S.",
        description: [
          "Sitio web corporativo especializado en ingeniería civil, construcción y contratación estatal (SECOP II).",
          "Presenta portafolio de servicios: Construcción, Diseños, Interventorías, Gerencia de Proyectos y Suministros.",
          "Diseño moderno y responsive enfocado en generar confianza y mostrar la experiencia de la empresa en obras públicas.",
          "Tecnologías utilizadas: React, Tailwind CSS, Vercel.",
        ],
      },
      taiyoPanel: {
        title: "Panel de Control - TAIYO",
        description: [
          "Sistema administrativo integral para la gestión de proyectos de construcción y licitaciones.",
          "Incluye dashboard con indicadores RUP, buscador de licitaciones con IA, control financiero y gestión de documentos.",
          "Herramientas especializadas para análisis de precios unitarios y seguimiento de cronogramas de obra.",
          "Tecnologías utilizadas: React, Tailwind CSS, Dashboard Analytics.",
        ],
      },
      opieka: {
        title: "Opieka Compani",
        description: [
          "Empresa del sector salud enfocada en soluciones tecnológicas para integración de datos clínicos y administrativos.",
          "Proyectos en Opieka: CUVServices.",
          "Desarrollo de una plataforma para integración de RIPS para el Ministerio de Salud con subida de archivos Excel y XML.",
          "Tecnologías utilizadas: React, TypeScript, PostgreSQL y Google Cloud.",
        ],
      },
    },
    en: {
      projectsTitle: "Projects",
      categories: {
        personal: "Personal",
        academic: "Academic",
        professional: "Professional"
      },
      maprounidad: {
        title: "Maprounidad",
        description: [
          "This software is a financial and administrative management system designed for organizations that require detailed control of members' contributions and loans.",
          "It facilitates common financial operations such as registering and tracking contributions, managing loans, and generating personalized reports.",
          "Technologies used: Python, React, PostgreSQL, and PDF generation.",
        ],
      },
      boft: {
        title: "Boft Photography Colombia",
        description: [
          "Boft is an international company specializing in photo printing, known for its franchises and kiosks in various parts of the world.",
          "Boft Colombia expanded its operations into the digital realm, in addition to its kiosks nationwide.",
          "A platform was developed that allows users to upload images, process online payments, and receive printed photos directly at their homes.",
          "Technologies used: Python, React, PostgreSQL, PDF generation, and Google Drive for cloud storage.",
        ],
      },
      quickbite: {
        title: "QuickBite",
        description: [
          "QuickBite is an enterprise SaaS platform that offers comprehensive solutions for restaurants, hardware stores, and retail businesses.",
          "The platform includes table management, digital ordering, inventory control, barcode scanning, point of sale, and business analytics.",
          "Specifically designed to maximize operational efficiency for different types of businesses with specialized industry features.",
          "Currently serving 1,200+ active companies, 98.7% customer satisfaction, and an average ROI of 35%.",
          "Project in development - Technologies: React, Python, PostgreSQL, Tailwind CSS, Supabase.",
        ],
      },
      muuva: {
        title: "MUUVA",
        description: [
          "MUUVA is a livestock commerce platform for Boyacá, Colombia that connects buyers and sellers of cattle (bovine, porcine, ovine, etc.).",
          "Escrow-style protected payment system (like MercadoLibre), where money is held until the buyer confirms delivery, ensuring security for both parties.",
          "Specially designed for the Colombian rural context with simplified WhatsApp registration and local payment methods (Nequi, Daviplata, Wompi, Efecty, Bancolombia).",
          "Includes auction system for competitive sales, multiple image uploads, catalog with advanced filters, and JWT authentication.",
          "Project in development - Technologies: React, TypeScript, Express, Prisma ORM, PostgreSQL, Tailwind CSS, Vite.",
        ],
      },
      emotionIA: {
        title: "EmotionIA - Emotion Classifier",
        description: [
          "Text emotion classifier that analyzes messages in Spanish or English and determines the predominant emotion: anger, fear, joy, love, sadness, or surprise.",
          "Human feedback system to continuously improve the model, with automatic translation and 90% accuracy using optimized LightGBM.",
          "Interactive web interface with Streamlit including probability visualizations, confusion matrices, and exploratory data analysis.",
          "Dataset of 420,458 records with collection of 5,026 human corrections for retraining.",
          "Technologies used: Python, LightGBM, scikit-learn, Streamlit, deep-translator, Plotly, pandas.",
        ],
      },
      pawmi: {
        title: "Pawmi - Pet Care App with AI",
        description: [
          "Pet care mobile application with AI that predicts diseases based on symptoms through an interactive chat.",
          "Complete system with FastAPI backend, JWT authentication and OAuth 2.0 with Google, pet management, and image uploads to Supabase.",
          "React Native frontend with Expo, visual pet selector, quick actions (vaccines, deworming), and modern gradient design.",
          "Machine Learning model with ExtraTreesClassifier achieving 98.15% accuracy in veterinary disease prediction.",
          "Technologies used: React Native, FastAPI, PostgreSQL (Supabase), scikit-learn, TypeScript, SQLAlchemy, Expo.",
        ],
      },
      turismoGastronomico: {
        title: "ML System for Gastronomic Tourism",
        description: [
          "Intelligent restaurant recommendation system for tourists in Tunja, Boyacá using Machine Learning with 100% real data. A 'Netflix for restaurants'.",
          "4 ML models: Random Forest (MAE 0.75), K-Means (4 tourist clusters), TF-IDF semantic search, and demand forecasting with 210 restaurants and 14,553 real interactions.",
          "Intelligent chat with semantic dish search, personalized recommendations based on history and clustering, visit forecasting for inventory planning.",
          "Complete dataset: 210 verified restaurants, 3,000 tourists with real profiles, exploratory analysis and model evaluation dashboard.",
          "Graduation project - Technologies: Python, scikit-learn, Streamlit, Pandas, NumPy, TF-IDF, K-Means, Random Forest.",
        ],
      },
      project4: {
        title: "Project 4",
        description: [
          "Coming soon...",
          "",
        ],
      },
      taiyoIngenieria: {
        title: "TAIYO Engineering S.A.S.",
        description: [
          "Corporate website specialized in civil engineering, construction, and state contracting (SECOP II).",
          "Presents service portfolio: Construction, Designs, Auditing, Project Management, and Supplies.",
          "Modern and responsive design focused on building trust and showcasing the company's experience in public works.",
          "Technologies used: React, Tailwind CSS, Vercel.",
        ],
      },
      taiyoPanel: {
        title: "TAIYO Control Panel",
        description: [
          "Integral administrative system for construction project management and bidding.",
          "Includes dashboard with RUP indicators, AI bidding search, financial control, and document management.",
          "Specialized tools for unit price analysis and construction schedule tracking.",
          "Technologies used: React, Tailwind CSS, Dashboard Analytics.",
        ],
      },
      opieka: {
        title: "Opieka Compani",
        description: [
          "Healthcare company focused on technology solutions for clinical and administrative data integration.",
          "Projects at Opieka: CUVServices.",
          "Development of a platform for RIPS integration for Colombia's Ministry of Health with Excel and XML file uploads.",
          "Technologies used: React, TypeScript, PostgreSQL, and Google Cloud.",
        ],
      },
    },
  };

  const currentTexts = texts[language] || texts.es;

  // Category options for RadioTabs
  const categoryOptions = [
    {
      value: 'personal',
      label: currentTexts.categories.personal,
      icon: (
        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
          <path d="M13 7h-2v5.414l3.293 3.293 1.414-1.414L13 11.586z"></path>
        </svg>
      )
    },
    {
      value: 'academic',
      label: currentTexts.categories.academic,
      icon: (
        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 7v1l11 4 9-4V7L11 4z"></path>
          <path d="M4 11v4.267c0 1.621 4.001 3.893 9 3.734 4-.126 6.586-1.972 7-3.467.024-.089.037-.178.037-.268V11L13 14l-5-1.667v3.213l-1-.364V12l-3-1z"></path>
        </svg>
      )
    },
    {
      value: 'professional',
      label: currentTexts.categories.professional,
      icon: (
        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 4H6c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9.414L14.586 4H10zm4 1.414L18.586 10H14V5.414zM8 12h8v2H8v-2zm0 4h8v2H8v-2z"></path>
        </svg>
      )
    }
  ];

  // All projects organized by category
  const allProjects = {
    personal: [
      {
        id: 'taiyoIngenieria',
        title: currentTexts.taiyoIngenieria.title,
        subtitle: language === 'es' ? 'Sitio Web Corporativo' : 'Corporate Website',
        description: currentTexts.taiyoIngenieria.description,
        image: taiyoWebImg,
        technologies: [
          { icon: <FaReact className="w-6 h-6" />, name: 'React', color: 'text-cyan-400' },
          { icon: <SiTailwindcss className="w-6 h-6" />, name: 'Tailwind CSS', color: 'text-teal-400' },
        ],
        status: 'completed',
        category: 'personal',
        demoUrl: 'https://taiyoingenieria.com',
      },
      {
        id: 'taiyoPanel',
        title: currentTexts.taiyoPanel.title,
        subtitle: language === 'es' ? 'Panel Administrativo' : 'Admin Dashboard',
        description: currentTexts.taiyoPanel.description,
        image: taiyoPanelImg,
        technologies: [
          { icon: <FaReact className="w-6 h-6" />, name: 'React', color: 'text-cyan-400' },
          { icon: <SiTailwindcss className="w-6 h-6" />, name: 'Tailwind CSS', color: 'text-teal-400' },
          { icon: <FaLaptopCode className="w-6 h-6" />, name: 'Analytics', color: 'text-purple-400' },
        ],
        status: 'development',
        category: 'personal'
      },
      {
        id: 'maprounidad',
        title: currentTexts.maprounidad.title,
        subtitle: language === 'es' ? 'Software de escritorio' : 'Desktop Software',
        description: currentTexts.maprounidad.description,
        image: maprounidadimg,
        technologies: [
          { icon: <FaPython className="w-6 h-6" />, name: 'Python', color: 'text-blue-400' },
          { icon: <FaReact className="w-6 h-6" />, name: 'React', color: 'text-cyan-400' },
          { icon: <SiPostgresql className="w-6 h-6" />, name: 'PostgreSQL', color: 'text-blue-600' },
          { icon: <FaFilePdf className="w-6 h-6" />, name: 'PDF', color: 'text-red-500' },
        ],
        status: 'completed',
        category: 'personal'
      },
      {
        id: 'boft',
        title: currentTexts.boft.title,
        subtitle: language === 'es' ? 'Aplicativo web' : 'Web Application',
        description: currentTexts.boft.description,
        image: boftimg,
        technologies: [
          { icon: <FaPython className="w-6 h-6" />, name: 'Python', color: 'text-blue-400' },
          { icon: <FaReact className="w-6 h-6" />, name: 'React', color: 'text-cyan-400' },
          { icon: <SiPostgresql className="w-6 h-6" />, name: 'PostgreSQL', color: 'text-blue-600' },
          { icon: <FaFilePdf className="w-6 h-6" />, name: 'PDF', color: 'text-red-500' },
          { icon: <FaGoogleDrive className="w-6 h-6" />, name: 'Google Drive', color: 'text-green-500' },
        ],
        status: 'completed',
        category: 'personal'
      },
      {
        id: 'quickbite',
        title: currentTexts.quickbite.title,
        subtitle: language === 'es' ? 'Plataforma SaaS Empresarial' : 'Enterprise SaaS Platform',
        description: currentTexts.quickbite.description,
        image: quikbiteimg,
        technologies: [
          { icon: <FaReact className="w-6 h-6" />, name: 'React', color: 'text-cyan-400' },
          { icon: <SiExpress className="w-6 h-6" />, name: 'Express', color: 'text-gray-400' },
          { icon: <SiPostgresql className="w-6 h-6" />, name: 'PostgreSQL', color: 'text-blue-600' },
          { icon: <SiTailwindcss className="w-6 h-6" />, name: 'Tailwind', color: 'text-teal-400' },
        ],
        status: 'development',
        category: 'personal'
      },
      {
        id: 'muuva',
        title: currentTexts.muuva.title,
        subtitle: language === 'es' ? 'Plataforma de Comercio Ganadero' : 'Livestock Commerce Platform',
        description: currentTexts.muuva.description,
        image: '/imgs/muuva.svg',
        technologies: [
          { icon: <FaReact className="w-6 h-6" />, name: 'React', color: 'text-cyan-400' },
          { icon: <SiTypescript className="w-6 h-6" />, name: 'TypeScript', color: 'text-blue-500' },
          { icon: <SiExpress className="w-6 h-6" />, name: 'Express', color: 'text-gray-400' },
          { icon: <SiPrisma className="w-6 h-6" />, name: 'Prisma', color: 'text-indigo-400' },
          { icon: <SiPostgresql className="w-6 h-6" />, name: 'PostgreSQL', color: 'text-blue-600' },
        ],
        status: 'development',
        category: 'personal'
      }
    ],
    academic: [
      {
        id: 'emotionIA',
        title: currentTexts.emotionIA.title,
        subtitle: language === 'es' ? 'Clasificador de Emociones con ML' : 'Emotion Classifier with ML',
        description: currentTexts.emotionIA.description,
        image: '/imgs/emotionIA.svg',
        technologies: [
          { icon: <FaPython className="w-6 h-6" />, name: 'Python', color: 'text-blue-400' },
          { icon: <SiScikitlearn className="w-6 h-6" />, name: 'scikit-learn', color: 'text-orange-500' },
          { icon: <SiStreamlit className="w-6 h-6" />, name: 'Streamlit', color: 'text-red-500' },
          { icon: <FaBrain className="w-6 h-6" />, name: 'LightGBM', color: 'text-purple-400' },
        ],
        status: 'completed',
        category: 'academic',
        demoUrl: 'https://emotionia-crykac8dehgglq8qkpcrfx.streamlit.app',
        githubUrl: 'https://github.com/Julianpril/emotionIA'
      },
      {
        id: 'pawmi',
        title: currentTexts.pawmi.title,
        subtitle: language === 'es' ? 'App Móvil de Mascotas con IA' : 'Pet Care Mobile App with AI',
        description: currentTexts.pawmi.description,
        image: '/imgs/pawmi.svg',
        technologies: [
          { icon: <FaReact className="w-6 h-6" />, name: 'React Native', color: 'text-cyan-400' },
          { icon: <SiFastapi className="w-6 h-6" />, name: 'FastAPI', color: 'text-green-500' },
          { icon: <SiTypescript className="w-6 h-6" />, name: 'TypeScript', color: 'text-blue-500' },
          { icon: <SiScikitlearn className="w-6 h-6" />, name: 'scikit-learn', color: 'text-orange-500' },
          { icon: <SiPostgresql className="w-6 h-6" />, name: 'PostgreSQL', color: 'text-blue-600' },
        ],
        status: 'development',
        category: 'academic'
      },
      {
        id: 'turismoGastronomico',
        title: currentTexts.turismoGastronomico.title,
        subtitle: language === 'es' ? 'Sistema de Recomendaciones con ML' : 'ML Recommendation System',
        description: currentTexts.turismoGastronomico.description,
        image: '/imgs/turismo-gastronomico.svg',
        technologies: [
          { icon: <FaPython className="w-6 h-6" />, name: 'Python', color: 'text-blue-400' },
          { icon: <SiScikitlearn className="w-6 h-6" />, name: 'scikit-learn', color: 'text-orange-500' },
          { icon: <SiStreamlit className="w-6 h-6" />, name: 'Streamlit', color: 'text-red-500' },
          { icon: <FaBrain className="w-6 h-6" />, name: 'Random Forest', color: 'text-purple-400' },
          { icon: <SiPandas className="w-6 h-6" />, name: 'Pandas', color: 'text-indigo-400' },
        ],
        status: 'completed',
        category: 'academic'
      }
    ],
    professional: [
      {
        id: 'opieka',
        title: currentTexts.opieka.title,
        subtitle: language === 'es' ? 'Empresa de tecnologia enfocada en el sector Salud' : 'Technology company focused on the healthcare sector',
        description: currentTexts.opieka.description,
        image: opiekaCompanyImg,
        technologies: [
          { icon: <FaReact className="w-6 h-6" />, name: 'React', color: 'text-cyan-400' },
          { icon: <SiTypescript className="w-6 h-6" />, name: 'TypeScript', color: 'text-blue-500' },
          { icon: <SiPostgresql className="w-6 h-6" />, name: 'PostgreSQL', color: 'text-blue-600' },
          { icon: <SiGooglecloud className="w-6 h-6" />, name: 'Google Cloud', color: 'text-yellow-400' },
        ],
        companyProjects: [
          {
            id: 'cuvservices',
            title: 'CUVServices',
            subtitle: language === 'es' ? 'Integracion RIPS - MinSalud' : 'RIPS Integration - Ministry of Health',
            description: [
              language === 'es'
                ? 'Desarrollo de una plataforma para integracion de RIPS para el Ministerio de Salud.'
                : "Development of a platform for RIPS integration for the Ministry of Health.",
              language === 'es'
                ? 'Incluye cargue y validacion de archivos Excel y XML para flujo de datos estandarizado.'
                : 'Includes upload and validation of Excel and XML files for a standardized data flow.',
              language === 'es'
                ? 'Tecnologias utilizadas: React, TypeScript, PostgreSQL y Google Cloud.'
                : 'Technologies used: React, TypeScript, PostgreSQL, and Google Cloud.',
            ],
            images: [
              cuvServicesImg,
              cuvServicesSubirImg,
            ],
            technologies: [
              { icon: <FaReact className="w-5 h-5" />, name: 'React', color: 'text-cyan-400' },
              { icon: <SiTypescript className="w-5 h-5" />, name: 'TypeScript', color: 'text-blue-500' },
              { icon: <SiPostgresql className="w-5 h-5" />, name: 'PostgreSQL', color: 'text-blue-600' },
              { icon: <SiGooglecloud className="w-5 h-5" />, name: 'Google Cloud', color: 'text-yellow-400' },
            ],
          },
          {
            id: 'ocr-automation',
            title: language === 'es' ? 'SOA Medical_Automatizacion OCR' : 'SOA Medical_OCR Automation',
            subtitle: language === 'es' ? 'Microservicios y flujos automáticos' : 'Microservices and automated flows',
            description: [
              language === 'es'
                ? 'Automatizacion OCR con arquitectura de microservicios para procesamiento documental.'
                : 'OCR automation with a microservices architecture for document processing.',
              language === 'es'
                ? 'Stack: React, Turborepo, Docker, TypeScript y n8n para orquestacion de procesos.'
                : 'Stack: React, Turborepo, Docker, TypeScript, and n8n for process orchestration.',
            ],
            images: [],
            technologies: [
              { icon: <FaReact className="w-5 h-5" />, name: 'React', color: 'text-cyan-400' },
              { icon: <FaLaptopCode className="w-5 h-5" />, name: 'Turborepo', color: 'text-white' },
              { icon: <SiTypescript className="w-5 h-5" />, name: 'TypeScript', color: 'text-blue-500' },
              { icon: <SiExpress className="w-5 h-5" />, name: 'Microservices', color: 'text-gray-300' },
            ],
          },
          {
            id: 'cuidamedoc',
            title: 'CuidameDoc (Clin-Sync)',
            subtitle: language === 'es' ? 'Gestión clínica y citas médicas' : 'Clinical management & appointments',
            description: [
              language === 'es'
                ? 'Backend y frontend para Clin-Sync, sistema de gestion clinica con modulos de citas medicas y notificaciones.'
                : 'Backend and frontend for Clin-Sync, a clinical management system with medical appointment and notification modules.',
              language === 'es'
                ? 'Migracion completa del frontend original en Angular/Ionic a React, consumiendo el backend real sin inventar campos ni endpoints.'
                : 'Full migration of the original Angular/Ionic frontend to React, consuming the real backend without inventing fields or endpoints.',
              language === 'es'
                ? 'Tecnologias utilizadas: React, TypeScript, Node.js y PostgreSQL.'
                : 'Technologies used: React, TypeScript, Node.js, and PostgreSQL.',
            ],
            images: [],
            technologies: [
              { icon: <FaReact className="w-5 h-5" />, name: 'React', color: 'text-cyan-400' },
              { icon: <SiTypescript className="w-5 h-5" />, name: 'TypeScript', color: 'text-blue-500' },
              { icon: <SiNodedotjs className="w-5 h-5" />, name: 'Node.js', color: 'text-green-500' },
              { icon: <SiPostgresql className="w-5 h-5" />, name: 'PostgreSQL', color: 'text-blue-600' },
            ],
          },
          {
            id: 'cuidamehealth',
            title: 'Cuídame Health',
            subtitle: language === 'es' ? 'Plataforma de salud para pacientes' : 'Healthcare platform for patients',
            description: [
              language === 'es'
                ? 'Plataforma principal de salud de Opieka: gestion de pacientes, beneficiarios, citas medicas y panel administrativo para agentes.'
                : "Opieka's main healthcare platform: patient and beneficiary management, medical appointments, and an admin panel for agents.",
              language === 'es'
                ? 'Backend NestJS y frontend en migracion de Angular/Ionic a React, con manillas/collares QR para verificacion de pacientes.'
                : 'NestJS backend and a frontend being migrated from Angular/Ionic to React, with QR wristbands/tags for patient verification.',
              language === 'es'
                ? 'Tecnologias utilizadas: React, NestJS, TypeScript y PostgreSQL.'
                : 'Technologies used: React, NestJS, TypeScript, and PostgreSQL.',
            ],
            images: [],
            technologies: [
              { icon: <FaReact className="w-5 h-5" />, name: 'React', color: 'text-cyan-400' },
              { icon: <SiNestjs className="w-5 h-5" />, name: 'NestJS', color: 'text-red-500' },
              { icon: <SiTypescript className="w-5 h-5" />, name: 'TypeScript', color: 'text-blue-500' },
              { icon: <SiPostgresql className="w-5 h-5" />, name: 'PostgreSQL', color: 'text-blue-600' },
            ],
          },
          {
            id: 'pets',
            title: 'Pets - Cuidame Tech',
            subtitle: language === 'es' ? 'Gestión de mascotas con historial clínico' : 'Pet management with clinical history',
            description: [
              language === 'es'
                ? 'Plataforma hermana de Cuidame Health para la gestion de mascotas con historial clinico.'
                : 'Sister platform to Cuídame Health for managing pets with a full clinical history.',
              language === 'es'
                ? 'Backend Node/Express/TypeORM y frontend React/Vite, con collares/manillas QR y flujo de onboarding.'
                : 'Node/Express/TypeORM backend and a React/Vite frontend, with QR tags/collars and an onboarding flow.',
              language === 'es'
                ? 'Tecnologias utilizadas: React, Node.js, Express y TypeORM.'
                : 'Technologies used: React, Node.js, Express, and TypeORM.',
            ],
            images: [],
            technologies: [
              { icon: <FaReact className="w-5 h-5" />, name: 'React', color: 'text-cyan-400' },
              { icon: <SiNodedotjs className="w-5 h-5" />, name: 'Node.js', color: 'text-green-500' },
              { icon: <SiExpress className="w-5 h-5" />, name: 'Express', color: 'text-gray-300' },
              { icon: <SiPostgresql className="w-5 h-5" />, name: 'PostgreSQL', color: 'text-blue-600' },
            ],
          },
          {
            id: 'miprescore',
            title: 'MIPRES Core',
            subtitle: language === 'es' ? 'Dispensación de tecnologías no-PBS ante MinSalud' : 'Non-PBS technology dispensing for the Ministry of Health',
            description: [
              language === 'es'
                ? 'Modulo de dispensacion MIPRES: descarga prescripciones desde los Web Services de MinSalud (SISPRO) y reporta los suministros.'
                : 'MIPRES dispensing module: pulls prescriptions from the Ministry of Health web services (SISPRO) and reports supplies back.',
              language === 'es'
                ? 'En produccion, con sincronizacion automatica, envio real a MinSalud e integracion con otros sistemas internos de Opieka.'
                : 'In production, with automatic syncing, real submissions to the Ministry of Health, and integration with other internal Opieka systems.',
              language === 'es'
                ? 'Tecnologias utilizadas: React, Node.js, Express y PostgreSQL.'
                : 'Technologies used: React, Node.js, Express, and PostgreSQL.',
            ],
            images: [],
            technologies: [
              { icon: <FaReact className="w-5 h-5" />, name: 'React', color: 'text-cyan-400' },
              { icon: <SiNodedotjs className="w-5 h-5" />, name: 'Node.js', color: 'text-green-500' },
              { icon: <SiExpress className="w-5 h-5" />, name: 'Express', color: 'text-gray-300' },
              { icon: <SiPostgresql className="w-5 h-5" />, name: 'PostgreSQL', color: 'text-blue-600' },
            ],
          },
          {
            id: 'opiekaweb',
            title: 'OpiekaWeb',
            subtitle: language === 'es' ? 'Sitio corporativo, CMS y reservas' : 'Corporate site, CMS & booking system',
            description: [
              language === 'es'
                ? 'Landing page, CMS administrable y sistema de reservas del propio sitio corporativo de Opieka.'
                : "Landing page, editable CMS, and booking system for Opieka's own corporate website.",
              language === 'es'
                ? 'Frontend en Next.js con animaciones (Framer Motion, React Three Fiber) y backend en Express con integracion a Google Calendar.'
                : 'Next.js frontend with animations (Framer Motion, React Three Fiber) and an Express backend integrated with Google Calendar.',
              language === 'es'
                ? 'Tecnologias utilizadas: Next.js, TypeScript, Express y Tailwind CSS.'
                : 'Technologies used: Next.js, TypeScript, Express, and Tailwind CSS.',
            ],
            images: [],
            technologies: [
              { icon: <SiNextdotjs className="w-5 h-5" />, name: 'Next.js', color: 'text-white' },
              { icon: <SiTypescript className="w-5 h-5" />, name: 'TypeScript', color: 'text-blue-500' },
              { icon: <SiExpress className="w-5 h-5" />, name: 'Express', color: 'text-gray-300' },
              { icon: <SiTailwindcss className="w-5 h-5" />, name: 'Tailwind CSS', color: 'text-teal-400' },
            ],
          },
          {
            id: 'medic-core-system',
            title: 'Medic Core System',
            subtitle: language === 'es' ? 'Autorizaciones médicas y transporte de pacientes' : 'Medical authorizations & patient transport',
            description: [
              language === 'es'
                ? 'Sistema de gestion de autorizaciones medicas y transporte de pacientes para SISTEMA MEDIC S.A.S.'
                : 'Medical authorization and patient transport management system for SISTEMA MEDIC S.A.S.',
              language === 'es'
                ? 'Ingesta de expedientes por correo o carga manual con OCR (Google Cloud Vision + Gemini), staging para aprobacion, programacion de servicios y analitica en BigQuery.'
                : 'Ingests records via email or manual upload with OCR (Google Cloud Vision + Gemini), a staging step for approval, service scheduling, and BigQuery analytics.',
              language === 'es'
                ? 'Tecnologias utilizadas: React, TypeScript, Prisma, PostgreSQL y Google Cloud.'
                : 'Technologies used: React, TypeScript, Prisma, PostgreSQL, and Google Cloud.',
            ],
            images: [],
            technologies: [
              { icon: <FaReact className="w-5 h-5" />, name: 'React', color: 'text-cyan-400' },
              { icon: <SiTypescript className="w-5 h-5" />, name: 'TypeScript', color: 'text-blue-500' },
              { icon: <SiPrisma className="w-5 h-5" />, name: 'Prisma', color: 'text-indigo-400' },
              { icon: <SiGooglecloud className="w-5 h-5" />, name: 'Google Cloud', color: 'text-yellow-400' },
            ],
          },
          {
            id: 'vehiculoscall',
            title: 'VehiculosCall',
            subtitle: language === 'es' ? 'Gestión de flota vehicular y conductores' : 'Vehicle fleet & driver management',
            description: [
              language === 'es'
                ? 'Sistema de gestion de flota vehicular y conductores para el transporte de pacientes: vehiculos, mantenimiento, rutas y empresas.'
                : 'Vehicle fleet and driver management system for patient transport: vehicles, maintenance, routes, and partner companies.',
              language === 'es'
                ? 'Monorepo con dashboard operativo, roles de usuario y control de excepciones y disponibilidad.'
                : 'Monorepo with an operational dashboard, user roles, and exception/availability tracking.',
              language === 'es'
                ? 'Tecnologias utilizadas: React, TypeScript, Express y PostgreSQL.'
                : 'Technologies used: React, TypeScript, Express, and PostgreSQL.',
            ],
            images: [],
            technologies: [
              { icon: <FaReact className="w-5 h-5" />, name: 'React', color: 'text-cyan-400' },
              { icon: <SiTypescript className="w-5 h-5" />, name: 'TypeScript', color: 'text-blue-500' },
              { icon: <SiExpress className="w-5 h-5" />, name: 'Express', color: 'text-gray-300' },
              { icon: <SiPostgresql className="w-5 h-5" />, name: 'PostgreSQL', color: 'text-blue-600' },
            ],
          },
        ],
        status: 'completed',
        category: 'professional'
      }
    ]
  };

  // Limitar a 4 proyectos por categoría en la vista principal
  const projects = (allProjects[selectedCategory] || []).slice(0, 4);
  const hasMoreProjects = (allProjects[selectedCategory] || []).length > 4;

  const getStatusBadge = (status) => {
    const statusConfig = {
      completed: {
        text: language === 'es' ? 'Completado' : 'Completed',
        color: 'bg-green-500/20 text-green-400 border-green-500/30'
      },
      development: {
        text: language === 'es' ? 'En Desarrollo' : 'In Development',
        color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30'
      },
      planning: {
        text: language === 'es' ? 'En Planificación' : 'Planning',
        color: 'bg-blue-500/20 text-blue-400 border-blue-500/30'
      }
    };

    const config = statusConfig[status] || statusConfig.planning;
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium border ${config.color}`}>
        {config.text}
      </span>
    );
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black px-4 py-16">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="font-jersey text-4xl md:text-6xl text-white mb-4">
            {currentTexts.projectsTitle}
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-teal-400 to-blue-400 mx-auto rounded-full" />
        </div>

        {/* Category Selector */}
        <div className="mb-12 flex justify-center">
          <RadioTabs
            options={categoryOptions}
            selectedValue={selectedCategory}
            onChange={setSelectedCategory}
            language={language}
          />
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project) => (
            <div
              key={project.id}
              className="group relative bg-gray-900 rounded-2xl overflow-hidden border border-gray-800 hover:border-gray-700 transition-all duration-300 cursor-pointer transform hover:scale-105"
              onClick={() => handleProjectClick(project)}
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  onError={(e) => {
                    // Fallback to technology icon if image fails to load
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900 items-center justify-center hidden">
                  <div className="text-6xl text-gray-600">
                    {project.technologies[0]?.icon}
                  </div>
                </div>
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-300" />

                {/* Status Badge */}
                <div className="absolute top-4 right-4">
                  {getStatusBadge(project.status)}
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-teal-400 transition-colors duration-300">
                  {project.title}
                </h3>
                <p className="text-gray-400 text-sm mb-4">{project.subtitle}</p>

                {/* Technologies */}
                <div className="mb-4">
                  <p className="text-gray-300 text-sm mb-2">
                    {language === 'es' ? 'Tecnologías' : 'Technologies'}
                  </p>
                  <div className="flex flex-wrap gap-3">
                    {project.technologies.map((tech, index) => (
                      <div
                        key={index}
                        className={`flex items-center space-x-2 ${tech.color} hover:scale-110 transition-transform duration-200`}
                        title={tech.name}
                      >
                        {tech.icon}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Brief Description */}
                <p className="text-gray-400 text-sm line-clamp-3 leading-relaxed mb-4">
                  {project.description[0]}
                </p>

                {/* Action Buttons */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.demoUrl && (
                    <a
                      href={project.demoUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      className="inline-flex items-center px-3 py-1.5 bg-teal-500/20 hover:bg-teal-500/30 text-teal-400 rounded-lg text-xs font-medium transition-colors duration-200 border border-teal-500/30"
                    >
                      <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                      {language === 'es' ? 'Ver Demo' : 'View Demo'}
                    </a>
                  )}
                  {project.githubUrl && (
                    <a
                      href={project.githubUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      className="inline-flex items-center px-3 py-1.5 bg-gray-700/50 hover:bg-gray-700 text-gray-300 rounded-lg text-xs font-medium transition-colors duration-200 border border-gray-600/50"
                    >
                      <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                      </svg>
                      GitHub
                    </a>
                  )}
                </div>

                {/* Learn More Button */}
                <div className="flex items-center text-teal-400 text-sm font-medium group-hover:text-teal-300 transition-colors duration-300">
                  <span>{language === 'es' ? 'Ver más detalles' : 'View details'}</span>
                  <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Ver todos los proyectos button - solo si hay más de 4 */}
        {hasMoreProjects && (
          <div className="text-center mt-12">
            <button
              onClick={() => {
                setAllProjectsCategory(selectedCategory);
                setShowAllProjectsModal(true);
              }}
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white rounded-xl font-medium transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
              </svg>
              {language === 'es' ? 'Ver todos los proyectos' : 'View all projects'}
              <span className="ml-2 px-2 py-0.5 bg-white/20 rounded-full text-xs">
                {(allProjects[selectedCategory] || []).length}
              </span>
            </button>
          </div>
        )}

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center space-x-4 bg-gray-900/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-800">
            <div className="text-center">
              <div className="text-2xl font-jersey text-teal-400 mb-1">
                {Object.values(allProjects).flat().filter(p => p.status === 'completed').length}
              </div>
              <div className="text-sm text-gray-400">
                {language === 'es' ? 'Completados' : 'Completed'}
              </div>
            </div>
            <div className="w-px h-12 bg-gray-700" />
            <div className="text-center">
              <div className="text-2xl font-jersey text-yellow-400 mb-1">
                {Object.values(allProjects).flat().filter(p => p.status === 'development').length}
              </div>
              <div className="text-sm text-gray-400">
                {language === 'es' ? 'En desarrollo' : 'In development'}
              </div>
            </div>
            <div className="w-px h-12 bg-gray-700" />
            <div className="text-center">
              <div className="text-2xl font-jersey text-blue-400 mb-1">
                {Object.values(allProjects).flat().filter(p => p.status === 'planning').length}
              </div>
              <div className="text-sm text-gray-400">
                {language === 'es' ? 'Planificados' : 'Planned'}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {companyProjectsModal.show && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gray-900 rounded-2xl max-w-4xl w-full max-h-[85vh] overflow-y-auto border border-gray-800">
            <div className="p-6 border-b border-gray-800 sticky top-0 bg-gray-900 z-10">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl md:text-3xl font-jersey text-white">
                    {companyProjectsModal.companyTitle}
                  </h2>
                  <p className="text-sm text-gray-400 mt-1">
                    {language === 'es' ? 'Proyectos en Opieka' : 'Projects at Opieka'}
                  </p>
                </div>
                <button
                  onClick={closeCompanyProjectsModal}
                  className="text-gray-400 hover:text-white transition-colors duration-200 p-2 hover:bg-gray-800 rounded-lg"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            <div className="p-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {companyProjectsModal.projects.map((companyProject) => (
                  <button
                    key={companyProject.id}
                    onClick={() => {
                      openModal(companyProject.title, companyProject.description, companyProject.images || []);
                      closeCompanyProjectsModal();
                    }}
                    className="text-left bg-gray-800/70 hover:bg-gray-800 rounded-xl border border-gray-700 hover:border-teal-500/50 p-5 transition-all duration-300"
                  >
                    {companyProject.images && companyProject.images.length > 0 && (
                      <div className="mb-3 h-28 rounded-lg overflow-hidden border border-gray-700">
                        <img
                          src={companyProject.images[0]}
                          alt={companyProject.title}
                          loading="lazy"
                          className="w-full h-full object-cover"
                        />
                      </div>
                    )}
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="text-lg font-bold text-white">{companyProject.title}</h3>
                      <span className="text-teal-400 text-xs font-medium">
                        {language === 'es' ? 'Abrir' : 'Open'}
                      </span>
                    </div>
                    <p className="text-sm text-gray-400 mb-3">{companyProject.subtitle}</p>
                    <div className="flex flex-wrap gap-2">
                      {companyProject.technologies.map((tech, index) => (
                        <div key={index} className={`${tech.color} w-5 h-5`} title={tech.name}>
                          {tech.icon}
                        </div>
                      ))}
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {modalData.show && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gray-900 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto border border-gray-800">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-white">{modalData.title}</h2>
                <button
                  onClick={closeModal}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="space-y-4">
                {modalData.content.map((paragraph, index) => (
                  <p key={index} className="text-gray-300 leading-relaxed">
                    {paragraph}
                  </p>
                ))}
              </div>
              {modalData.images && modalData.images.length > 0 && (
                <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {modalData.images.map((imageSrc, index) => (
                    <div key={index} className="rounded-lg overflow-hidden border border-gray-700 bg-gray-800">
                      <img
                        src={imageSrc}
                        alt={`${modalData.title} ${index + 1}`}
                        loading="lazy"
                        className="w-full h-44 object-cover"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal de Todos los Proyectos */}
      {showAllProjectsModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4 overflow-y-auto">
          <div className="bg-gray-900 rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto border border-gray-800">
            <div className="sticky top-0 bg-gray-900 border-b border-gray-800 p-6 z-10">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-3xl font-jersey text-white mb-2">
                    {language === 'es' ? 'Todos los Proyectos' : 'All Projects'}
                  </h2>
                  <p className="text-gray-400 text-sm">
                    {currentTexts.categories[allProjectsCategory]} - {(allProjects[allProjectsCategory] || []).length} {language === 'es' ? 'proyectos' : 'projects'}
                  </p>
                </div>
                <button
                  onClick={() => setShowAllProjectsModal(false)}
                  className="text-gray-400 hover:text-white transition-colors duration-200 p-2 hover:bg-gray-800 rounded-lg"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            <div className="p-6">
              {/* Category Tabs dentro del modal */}
              <div className="mb-8 flex justify-center">
                <RadioTabs
                  options={categoryOptions}
                  selectedValue={allProjectsCategory}
                  onChange={(category) => setAllProjectsCategory(category)}
                  language={language}
                />
              </div>

              {/* Grid de TODOS los proyectos */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {(allProjects[allProjectsCategory] || []).map((project) => (
                  <div
                    key={project.id}
                    className="group relative bg-gray-800/50 rounded-xl overflow-hidden border border-gray-700 hover:border-gray-600 transition-all duration-300 cursor-pointer transform hover:scale-105"
                    onClick={() => {
                      handleProjectClick(project, true);
                    }}
                  >
                    {/* Image */}
                    <div className="relative h-36 overflow-hidden">
                      <img
                        src={project.image}
                        alt={project.title}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                      <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900 items-center justify-center hidden">
                        <div className="text-4xl text-gray-600">
                          {project.technologies[0]?.icon}
                        </div>
                      </div>
                      <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-300" />

                      {/* Status Badge */}
                      <div className="absolute top-3 right-3">
                        {getStatusBadge(project.status)}
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-4">
                      <h3 className="text-lg font-bold text-white mb-1 group-hover:text-teal-400 transition-colors duration-300 line-clamp-1">
                        {project.title}
                      </h3>
                      <p className="text-gray-400 text-xs mb-3 line-clamp-1">{project.subtitle}</p>

                      {/* Technologies */}
                      <div className="flex flex-wrap gap-2 mb-3">
                        {project.technologies.slice(0, 4).map((tech, index) => (
                          <div
                            key={index}
                            className={`${tech.color} hover:scale-110 transition-transform duration-200`}
                            title={tech.name}
                          >
                            <div className="w-5 h-5">
                              {tech.icon}
                            </div>
                          </div>
                        ))}
                        {project.technologies.length > 4 && (
                          <div className="text-gray-500 text-xs self-center">
                            +{project.technologies.length - 4}
                          </div>
                        )}
                      </div>

                      {/* Brief Description */}
                      <p className="text-gray-400 text-xs line-clamp-2 leading-relaxed mb-3">
                        {project.description[0]}
                      </p>

                      {/* Action Buttons */}
                      {(project.demoUrl || project.githubUrl) && (
                        <div className="flex flex-wrap gap-2 mb-2">
                          {project.demoUrl && (
                            <a
                              href={project.demoUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                              className="inline-flex items-center px-2 py-1 bg-teal-500/20 hover:bg-teal-500/30 text-teal-400 rounded text-xs font-medium transition-colors duration-200"
                            >
                              <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              </svg>
                              Demo
                            </a>
                          )}
                          {project.githubUrl && (
                            <a
                              href={project.githubUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                              className="inline-flex items-center px-2 py-1 bg-gray-700/50 hover:bg-gray-700 text-gray-300 rounded text-xs font-medium transition-colors duration-200"
                            >
                              <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                              </svg>
                              GitHub
                            </a>
                          )}
                        </div>
                      )}

                      {/* Learn More */}
                      <div className="flex items-center text-teal-400 text-xs font-medium group-hover:text-teal-300 transition-colors duration-300">
                        <span>{language === 'es' ? 'Ver detalles' : 'View details'}</span>
                        <svg className="w-3 h-3 ml-1 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectsSection;